document.addEventListener('DOMContentLoaded', function() {
  // Elementi del DOM
  const container = document.getElementById('blog-articles-container');
  const loadingIndicator = document.getElementById('loading-indicator');
  const articles = Array.from(document.querySelectorAll('.full-article'));
  
  // Variabili di stato
  let currentArticleIndex = 0;
  let isLoading = false;
  let lastScrollPosition = 0;
  let scrollTimeout;

  // Nascondi tutti gli articoli tranne il primo
  articles.forEach((article, index) => {
    article.style.display = index === 0 ? 'block' : 'none';
  });

  // FUNZIONE CHIAVE: Corregge il problema del doppio "news"
  function updateURL(articleHandle) {
    // 1. Pulisci l'handle rimuovendo slash e "news" duplicati
    const cleanHandle = articleHandle
      .replace(/^\/+/, '')               // Rimuove slash iniziali
      .replace(/news\//, '')             // Rimuove "news/" se presente
      .replace(/\/$/, '');               // Rimuove slash finali
    
    // 2. Costruisci l'URL corretto
    const newUrl = `/blogs/news/${cleanHandle}`;
    
    // 3. Aggiorna solo se l'URL è diverso dall'attuale
    if (window.location.pathname !== newUrl) {
      window.history.replaceState({ path: newUrl }, '', newUrl);
    }
  }

  // Controlla se un articolo è visibile
  function isArticleVisible(article) {
    const rect = article.getBoundingClientRect();
    return (
      rect.top <= window.innerHeight * 0.4 &&
      rect.bottom >= window.innerHeight * 0.2
    );
  }

  // Gestione dello scroll con debounce
  function handleScroll() {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      const scrollPosition = window.scrollY;
      
      // Trova l'articolo attualmente visibile
      articles.forEach((article, index) => {
        if (article.style.display === 'block' && isArticleVisible(article)) {
          if (index !== currentArticleIndex) {
            currentArticleIndex = index;
            updateURL(article.dataset.articleHandle);
          }
        }
      });

      // Carica il prossimo articolo se siamo vicini al fondo
      if (!isLoading && 
          currentArticleIndex < articles.length - 1 &&
          window.innerHeight + window.scrollY >= document.body.offsetHeight - 500) {
        loadNextArticle();
      }
    }, 100);
  }

  // Carica il prossimo articolo
  function loadNextArticle() {
    if (isLoading || currentArticleIndex >= articles.length - 1) return;
    
    isLoading = true;
    loadingIndicator.style.display = 'block';
    
    setTimeout(() => {
      const nextArticle = articles[currentArticleIndex + 1];
      nextArticle.style.display = 'block';
      currentArticleIndex++;
      
      isLoading = false;
      loadingIndicator.style.display = 'none';
    }, 300);
  }

  // Inizializzazione
  function init() {
    // Gestione URL iniziale
    const pathParts = window.location.pathname.split('/');
    const currentHandle = pathParts.pop() || pathParts.pop(); // Handle sicuro
    
    if (currentHandle && currentHandle !== 'news') {
      const targetArticle = articles.find(article => 
        article.dataset.articleHandle === currentHandle ||
        article.id === `article-${currentHandle}`
      );
      
      if (targetArticle) {
        const targetIndex = articles.indexOf(targetArticle);
        
        // Mostra tutti gli articoli fino al target
        articles.forEach((article, index) => {
          if (index <= targetIndex) article.style.display = 'block';
        });
        
        // Scroll all'articolo
        setTimeout(() => {
          targetArticle.scrollIntoView({ behavior: 'smooth' });
          currentArticleIndex = targetIndex;
        }, 200);
      }
    }

    // Event listeners
    window.addEventListener('scroll', handleScroll, { passive: true });
  }

  init();
});